module.exports = {
    buttons: 'col-sm-offset-2 col-sm-10 btn-group',
    button: 'btn',
    buttonContainer: "form-group",
    primary: 'btn-primary'
};


/** WEBPACK FOOTER **
 ** ./~/subschema/src/styles/ButtonsTemplate-style.js
 **/